import { render, staticRenderFns } from "./WxMoveConfig.vue?vue&type=template&id=278a89c7&scoped=true"
import script from "./WxMoveConfig.vue?vue&type=script&lang=js"
export * from "./WxMoveConfig.vue?vue&type=script&lang=js"
import style0 from "./WxMoveConfig.vue?vue&type=style&index=0&id=278a89c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.43_cache-loader@4.1.0_webpack@4.47.0_supports-_28b733ef3ef89602fda58894ac543489/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278a89c7",
  null
  
)

export default component.exports